import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'provisioning',
});

export const rootCatalogProvisioningRouteRef = createRouteRef({
  id: 'provisioning.entity',
});
